import {
  createEntityAdapter,
  createSlice,
  createReducer,
  configureStore,
} from '@reduxjs/toolkit'

const store = configureStore({
  reducer: {
    dummy: () => ({})
  },
  devTools: {
    name: 'Tutorial',
  },
})

export default store
